import type { PageNumber } from "@pdfking/renderer-api"
import { NullQ } from "@pdfking/structs"
export const SignatureSizeForBinding = (
  blueline_page_numbers: PageNumber[][],
  page_numbers_to_sheet_cover_index: Record<PageNumber, number>
): number[] => {
  if (!blueline_page_numbers.length) return []
  const result: number[] = []
  let count = 0
  for (const line of blueline_page_numbers) {
    const page = line[line.length - 1]
    if (NullQ(page)) continue
    if (page in page_numbers_to_sheet_cover_index) {
      if (count) result.push(count)
      count = 0
    }
    count += 1
  }
  if (count) result.push(count)
  return result
}
